/**
 * Hebrew strings for passenger checkout UI — merged under completepassengers after fetch.
 * Ensures new keys resolve even when /locales/he.json is served from an HTTP cache.
 */

export const completepassengersHeFallback = {
  checkoutPageTitle: "פרטי נוסעים",
  checkoutPageSubtitle:
    "מלאו את הפרטים כפי שמופיעים בדרכון. לאחר האישור נעבור לתשלום.",
  stepChooseRoom: "בחירת חדר",
  stepPassengers: "פרטי נוסעים",
  stepPayment: "תשלום ואישור",
  stepProgressAria: "התקדמות בתהליך ההזמנה",
  continueNextStep: "המשך לתשלום",
  footerBack: "חזרה לבחירת חדר",
  mobileOrderSummary: "סיכום הזמנה",
  secureBookingTitle: "הזמנה מאובטחת",
  secureBookingHint:
    "הנתונים מועברים בחיבור מוצפן. התשלום יתבצע בעמוד הבא.",
  approveTermsLead: "אשר ",
  termsOfSiteLink: "תנאי האתר",
  approveTermsBetween: " ו",
  cancellationPolicyLink: "מדיניות ביטול",
  payLaterUnavailableHint:
    "לא ניתן לבחור הזמנה ותשלום מאוחר עבור הצעה זו. ניתן להמשיך לתשלום מיידי.",
  occupancyLabel: "תפוסה",
  boardLabel: "בסיס אירוח",
  cancelSnippet: "ביטול",
  duplicateallpassengers: "העתק פרטים לכל הנוסעים",
  passangernum: "נוסע",
  contanctman: "איש קשר",
  contanctmannote: "איש הקשר הראשי להזמנה",
  gender: "מין",
  male: "זכר",
  female: "נקבה",
  firstname: "שם פרטי",
  lastname: "שם משפחה",
  cell: "טלפון",
  email: "אימייל",
  birthdate: "תאריך לידה",
  room: "חדר",
  freecancelation: "ביטול חינם עד",
  nofreecancelation: "ללא ביטול חינם",
  kid: "ילד",
  infant: "תינוק",
  adult: "מבוגר",
  guestsLabel: "אורחים",
  boardBasis: "בסיס אירוח",
  showRoomDetails: "הצג פרטי חדר",
  dates: "תאריכים",
  totalPrice: "מחיר כולל",
  noRoomImagesFound: "לא נמצאו תמונות לחדר",
  prevPhoto: "תמונה קודמת",
  nextPhoto: "תמונה הבאה",
  specialrequests: "בקשות מיוחדות",
  specialrequeststext: "הוסף בקשות מיוחדות, אם יש",
  policycanclationhotel: "מדיניות ביטול",
  cancellationPolicy: "מדיניות ביטול",
};
